import { render, staticRenderFns } from "./GenderAndAgeMetricsChart.vue?vue&type=template&id=6649b7a6&scoped=true"
import script from "./GenderAndAgeMetricsChart.vue?vue&type=script&lang=js"
export * from "./GenderAndAgeMetricsChart.vue?vue&type=script&lang=js"
import style0 from "./GenderAndAgeMetricsChart.vue?vue&type=style&index=0&id=6649b7a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6649b7a6",
  null
  
)

export default component.exports